import React from 'react';

export const parseMarkdownText = (text: string): React.ReactNode => {
  if (!text) return null;

  const nodes: React.ReactNode[] = [];
  const regex = /(\*\*(.+?)\*\*|__(.+?)__|~~(.+?)~~|\*(.+?)\*)/g;
  let lastIndex = 0;
  let match;
  let key = 0;

  while ((match = regex.exec(text)) !== null) {
    const fullMatch = match[0];
    const matchStart = match.index;

    if (matchStart > lastIndex) {
      nodes.push(text.slice(lastIndex, matchStart));
    }

    let content = '';
    let elementTag: 'strong' | 'u' | 'del' | 'em' = 'strong';

    if (/^\*\*(.*)\*\*$/.test(fullMatch)) {
      elementTag = 'strong';
      content = fullMatch.slice(2, -2);
    } else if (/^__(.*)__$/.test(fullMatch)) {
      elementTag = 'u';
      content = fullMatch.slice(2, -2);
    } else if (/^~~(.*)~~$/.test(fullMatch)) {
      elementTag = 'del';
      content = fullMatch.slice(2, -2);
    } else if (/^\*(.*)\*$/.test(fullMatch)) {
      elementTag = 'em';
      content = fullMatch.slice(1, -1);
    } else {
      content = fullMatch;
    }

    nodes.push(
      React.createElement(elementTag, { key: `md-${key++}` }, content)
    );
    lastIndex = regex.lastIndex;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
};

export default parseMarkdownText;
